import { styled } from '@mui/system';
import { colors } from 'Constants/Colors';
// import { Tab } from '@mui/material';
import { TabPanel, TabList, TabContext } from '@mui/lab';

export const CustomTab = styled(TabPanel)`
  font-family: var(--app-font);
  color: ${colors.GRAY_DARKER};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  padding: 1rem 3rem;
  border: none;
  border-radius: 2rem;
  display: flex;
  justify-content: center;
  background-color: ${colors.BLUE_GRAY};
`;

export const CustomTabPanel = styled(TabPanel)`
  width: 100%;
  padding: 0;
`;

export const CustomTabsList = styled(TabList)`
  display: flex;
  gap: 1rem;
  margin-bottom: 3rem;
`;

export default {
  CustomTab,
  CustomTabPanel,
  CustomTabsList,
};
